import { ky } from './ky';
import { ListResponse } from './common';

export type InquiryStatus = 'OPEN' | 'IN_PROGRESS' | 'CLOSED';

export interface InquiryTicketDto {
  id: number;
  title: string;
  status: InquiryStatus;
  createdAt: string;
  updatedAt: string;
  messages?: InquiryMessageDto[];
}

export interface InquiryMessageDto {
  id: number;
  content: string;
  isAdmin: boolean;
  createdAt: string;
  senderNickname: string;
}

export default class InquiryService {
  async createTicket(title: string, content: string) {
    return await ky.post('v1/inquiries', {
      json: { title, content },
    }).json() as InquiryTicketDto;
  }

  async addMessage(ticketId: number, content: string) {
    return await ky.post(`v1/inquiries/${ticketId}/messages`, {
      json: { content },
    }).json() as InquiryMessageDto;
  }

  async getMyTickets() {
    return await ky.get('v1/inquiries').json() as ListResponse<InquiryTicketDto>;
  }

  async getTicketDetail(ticketId: number) {
    return await ky.get(`v1/inquiries/${ticketId}`).json() as InquiryTicketDto;
  }

  async updateTicketStatus(ticketId: number, status: InquiryStatus) {
    return await ky.patch(`v1/inquiries/${ticketId}/status`, {
      json: { status },
    }).json() as InquiryTicketDto;
  }
}
